// extracted by mini-css-extract-plugin
export default {"container":"A6GtSq","withTopOverlay":"V0xEME","withRightOverlay":"sga6k5","cta":"xKcsWy","ctaTextOnBottom":"BZlpFY","desktopBreakline":"F_mX6H"};